"use strict";

exports.__esModule = true;
exports.GroupedBarChartSeries = void 0;
var _react = _interopRequireWildcard(require("react"));
var _d3Selection = require("d3-selection");
var _UiDesignContext = require("../../Theme/UiDesign/UiDesignContext");
var _excluded = ["width", "height", "series", "xScale", "yScale", "color"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Displays bar chart series.
 */
// eslint-disable-next-line no-shadow
var GroupedBarChartSeries = exports.GroupedBarChartSeries = /*#__PURE__*/function (_Component) {
  function GroupedBarChartSeries() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.registerContainer = function (container) {
      _this.container = container;
      if (container != null) {
        _this.applyValues(container);
      }
    };
    return _this;
  }
  _inheritsLoose(GroupedBarChartSeries, _Component);
  var _proto = GroupedBarChartSeries.prototype;
  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.container != null) {
      this.applyValues(this.container);
    }
  };
  _proto.applyValues = function applyValues(container) {
    var _this$props = this.props,
      series = _this$props.series,
      color = _this$props.color,
      width = _this$props.width,
      height = _this$props.height,
      xScale = _this$props.xScale,
      yScale = _this$props.yScale;
    var data = series.data,
      getXValue = series.getXValue,
      getYValue = series.getYValue;
    var barWidth = typeof xScale.bandwidth === "function" ? xScale.bandwidth() : width / data.length;
    var g = (0, _d3Selection.select)(container);
    g.selectAll(".bar").data(data).enter().append("rect").attr("rx", this.context && this.context.modern ? 3 : null).attr("class", "bar").attr("fill", function (item) {
      return typeof color === "function" ? color(item) : color;
    }).attr("x", function (item) {
      return xScale(getXValue(item));
    }).attr("y", function (item) {
      return yScale(getYValue(item));
    }).attr("width", barWidth).attr("height", function (item) {
      return height - yScale(getYValue(item));
    });
  };
  _proto.render = function render() {
    var _this$props2 = this.props,
      width = _this$props2.width,
      height = _this$props2.height,
      series = _this$props2.series,
      xScale = _this$props2.xScale,
      yScale = _this$props2.yScale,
      color = _this$props2.color,
      extra = _objectWithoutPropertiesLoose(_this$props2, _excluded);
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      width: width,
      height: height,
      ref: this.registerContainer
    }, extra));
  };
  return GroupedBarChartSeries;
}(_react.Component);
GroupedBarChartSeries.contextType = _UiDesignContext.UiDesignContext;